import React, { useState, useEffect, Fragment, useMemo } from "react";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Snackbar from "@material-ui/core/Snackbar";
import Fade from "@material-ui/core/Fade";
import { base_url } from "../Api/Api";
import { Scrollbar } from "react-scrollbars-custom";
import { HalfCircleSpinner } from "react-epic-spinners";
import EntrnaceHeader from "./EntranceHeader";
import {
  ListSubheader,
} from "@mui/material";
// import { ListSubheader } from "@mui/material";
const Shopinfo = (props) => {
  const [snakCity, setSnakCity] = useState({
    open: false,
    Transition: Fade,
  });
  const [snakProvince, setSnakProvince] = useState({
    open: false,
    Transition: Fade,
  });

  const [animation, setAnimation] = useState(false);
  const [province, setProvince] = useState([]); // Province
  const [City, setCity] = useState([]); // City
  const [shop, setShop] = useState([]); // shop
  const [searchText, setSearchText] = useState("");
  const [status, setStatus] = useState({
    noContent: true,
    noContentCity: true,
  });
  const [state, setState] = useState({
    checked: false,
    selectedProvince: "",
    selectedCity: "",
    selectedShop: "",
    errorValid: false,
  });

  useEffect(() => {
    setTimeout(() => {
      setAnimation(true);
    }, 300);

    if (
      localStorage.getItem("shopInfo") !== null &&
      localStorage.getItem("shopDetails") !== null
    ) {
      const infoPerson = JSON.parse(localStorage.getItem("shopInfo"));
      const shopDetails = JSON.parse(localStorage.getItem("shopDetails"));
      setState({
        ...state,
        selectedProvince: infoPerson.province,
        selectedCity: infoPerson.city,
        selectedShop: infoPerson.shop,
        checked: infoPerson.manager,
      });
      setProvince(shopDetails.province);
      setCity(shopDetails.City);
      setShop(shopDetails.shop);
      document.getElementById("provinceValue").innerHTML =
        infoPerson.province.name;
      document.getElementById("cityValue").innerHTML = infoPerson.city.name;
      document.getElementById("shopValue").innerHTML = infoPerson.shop.name;
      document.getElementById("province").classList.add("MuiInputLabel-shrink");
      document.getElementById("city").classList.add("MuiInputLabel-shrink");
      document.getElementById("shop").classList.add("MuiInputLabel-shrink");
    }

    // set province

    base_url
      .get("getProvinces")
      .then((response) => {
        setProvince(response.data.provinces);
        setStatus({
          ...status,
          noContent: response.data.provinces.length == 0,
        });
      });
  }, []);

  const getCity = (id) => {
    setCity([]);
    // set Citys

    base_url
      .get(`cities/${id}`)
      .then((response) => {
        setCity(response.data.cities);
        setStatus({
          ...status,
          noContent: false,
        });
      });
  };

  const getShop = (id) => {
    setShop([]);
    // set Citys

    base_url
      .get(`stores/${id}`)
      .then((response) => {
        setShop(response.data.stores);
      });
  };

  const handleCloseCity = () => {
    setSnakCity({
      ...snakCity,
      open: false,
    });
  };

  const handleCloseProvince = () => {
    setSnakProvince({
      ...snakProvince,
      open: false,
    });
  };

  const handleChangeManeger = (event) => {
    setState({
      ...state,
      checked: event.target.checked,
    });
  };

  // set value of
  const handleChange = (info, target) => {
    if (target == "selectedProvince") {
      setState({
        ...state,
        [target]: info,
        selectedCity: "",
        selectedShop: "",
      });
      document.getElementById("provinceValue").innerHTML = info.name;
      document.getElementById("cityValue").innerHTML = null;
      document.getElementById("shopValue").innerHTML = null;
      getCity(info.id);
    } else if (target == "selectedCity") {
      getShop(info.id);
      setState({
        ...state,
        [target]: info,
        selectedShop: "",
      });
      document.getElementById("cityValue").innerHTML = info.name;
      document.getElementById("shopValue").innerHTML = null;
    } else if (target == "selectedShop") {
      setState({
        ...state,
        [target]: info,
      });
      document.getElementById("shopValue").innerHTML = info.name;
    }
  };

  const addNewShop = () => {
    setAnimation(false);
    setTimeout(() => {
      props.history.push("/entrance/step5");
    }, 300);
  };

  const contniue = () => {
    const data = {
      province: state.selectedProvince,
      city: state.selectedCity,
      shop: state.selectedShop,
      manager: state.checked,
    };
    const shopDetails = {
      province: province,
      City: City,
      shop: shop,
    };
    if (
      state.selectedProvince.length !== 0 &&
      state.selectedCity.length !== 0 &&
      state.selectedShop.length !== 0
    ) {
      localStorage.setItem("shopDetails", JSON.stringify(shopDetails));
      localStorage.setItem("shopInfo", JSON.stringify(data));
      setAnimation(false);
      setTimeout(() => {
        props.history.push("/entrance/step6");
      }, 300);
    } else {
      setState({
        ...state,
        errorValid: true,
      });
    }
  };
  const containsText = (text, searchText) =>
    text.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  const shops = useMemo(
    () => shop.filter((option) => containsText(option, searchText)),
    [searchText]
  );
  return (
    <Fragment>
      <EntrnaceHeader />
      <div
        id="shopInfo"
        className={`entrnc-web shop-info ${animation ? "active" : ""}`}
      >
        <Snackbar
          open={snakCity.open}
          onClose={handleCloseCity}
          TransitionComponent={snakCity.Transition}
          message="ابتدا استان را انتخاب کنید"
          key={snakCity.Transition.name}
        />
        <Snackbar
          open={snakProvince.open}
          onClose={handleCloseProvince}
          TransitionComponent={snakProvince.Transition}
          message="ابتدا شهر را انتخاب کنید"
          key={snakProvince.Transition.name}
        />
        <div className="bx-info">
          <div className="titles-style-1">
            <h4>اطلاعات فروشگاه</h4>
          </div>

          <div className="step-progress">
            <span className="active"></span>
            <span className="active"></span>
            <span></span>
          </div>
          <div className="info-inputs select-input">
            <div className={`input-form`}>
              <FormControl>
                <InputLabel id="province">استان</InputLabel>
                <i className="icon-arrow-down-sign-to-navigate"></i>
                <Select
                  labelId="province"
                  id="provinceValue"
                  value={state.selectedProvince}
                >
                  <Scrollbar
                    className={`entrance-web 
                                    ${
                                      province.length >= 10
                                        ? "normal"
                                        : province.length >= 5
                                        ? "min"
                                        : "zero"
                                    }`}
                  >
                    {province.length == 0 ? (
                      status.noContent ? (
                        <div className="loader-item">
                          <HalfCircleSpinner size={35} color="#1e1e1e" />
                        </div>
                      ) : (
                        <span className="no-info">
                          موردی برای نمایش وجود ندارد
                        </span>
                      )
                    ) : (
                      province.map((info) => (
                        <MenuItem
                          key={info.id}
                          onClick={() => handleChange(info, "selectedProvince")}
                        >
                          {info.name}
                        </MenuItem>
                      ))
                    )}
                  </Scrollbar>
                </Select>
              </FormControl>

              <span
                className={`error-respns ${
                  state.errorValid && state.selectedProvince.length == 0
                    ? "active"
                    : ""
                }`}
              >
                <i className="icon-exclamation-mark"></i>
                استان خود را انتخاب کنید
              </span>
            </div>
            <div className={`input-form`}>
              <FormControl disabled={state.selectedProvince.length == 0}>
                <InputLabel id="city">شهر</InputLabel>
                <i className="icon-arrow-down-sign-to-navigate"></i>

                <Select
                  labelId="city"
                  id="cityValue"
                  value={state.selectedCity}
                >
                  <Scrollbar
                    className={`entrance-web 
                                    ${
                                      City.length >= 10
                                        ? "normal"
                                        : City.length >= 5
                                        ? "min"
                                        : "zero"
                                    }`}
                  >
                    {City.length == 0 ? (
                      status.noContentCity ? (
                        <div className="loader-item">
                          <HalfCircleSpinner size={35} color="#1e1e1e" />
                        </div>
                      ) : (
                        <span className="no-info">
                          موردی برای نمایش وجود ندارد
                        </span>
                      )
                    ) : (
                      City.map((info) => (
                        <MenuItem
                          key={info.id}
                          onClick={() => handleChange(info, "selectedCity")}
                        >
                          {info.name}
                        </MenuItem>
                      ))
                    )}
                  </Scrollbar>
                </Select>
              </FormControl>
              <span
                className={`error-respns ${
                  state.errorValid && state.selectedCity.length == 0
                    ? "active"
                    : ""
                }`}
              >
                <i className="icon-exclamation-mark"></i>
                شهر خود را انتخاب کنید
              </span>
            </div>
            <div className={`input-form`}>
              <FormControl disabled={state.selectedCity.length == 0}>
                <InputLabel id="shop">نام فروشگاه</InputLabel>
                <i className="icon-arrow-down-sign-to-navigate"></i>
                <Select
                  // Disables auto focus on MenuItems and allows TextField to be in focus
                  MenuProps={{ autoFocus: false }}
                  labelId="shop"
                  id="shopValue"
                  value={state.selectedShop}
                  onClose={() => setSearchText("")}
              
                >
                  <ListSubheader>
                    <input
                      autoFocus
                      placeholder="جستجو"
                      className="searchInput"
                      type="text"
                      onClick={(e) => { e.stopPropagation(); }}
                      onFocus={() => setSearchText(" ")}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          // Prevents autoselecting item while typing (default Select behaviour)
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  <Scrollbar
                    className={`entrance-web 
                                    ${shop.length >= 3 ? "normal" : "zero"}`}
                  >
                    <FormControl component="fieldset" className="radio-bnts">
                      <RadioGroup
                        aria-label="stores"
                        name="stores"
                        value={state.selectedShop.id}
                      >
                        {shops.length == 0 ? (
                          <span className="no-info store">
                            <i className="icon-store"></i>
                            موردی برای نمایش وجود ندارد
                          </span>
                        ) : (
                          shops.map((info, index) => (
                            <div className="radio-btn" key={index}>
                              <FormControlLabel
                              
                                key={info.id}
                                value={info.id}
                                control={<Radio />}
                                label={info.name}
                                onClick={() =>
                                  handleChange(info, "selectedShop")
                                }
                              />
                              <p>{info.address}</p>
                            </div>
                          ))
                        )}
                      </RadioGroup>
                    </FormControl>
                  </Scrollbar>
                </Select>
              </FormControl>

              <span
                className={`error-respns ${
                  state.errorValid && state.selectedShop.length == 0
                    ? "active"
                    : ""
                }`}
              >
                <i className="icon-exclamation-mark"></i>
                فروشگاه خود را انتخاب کنید
              </span>
            </div>

            <div className="input-form checkbox">
              <button type="button" onClick={addNewShop}>
                <i>+</i>
                افزودن فروشگاه
              </button>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={state.checked}
                    onChange={handleChangeManeger}
                    inputProps={{ "aria-label": "primary checkbox" }}
                    color="primary"
                  />
                }
                label="مدیر فروشگاه هستم"
              />
            </div>
          </div>
          <div className="btn-base btn-black btn-sircle">
            <Button variant="contained" onClick={contniue}>
              ادامه
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Shopinfo;
